import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Customer} from '../models/customer';

@Injectable({
  providedIn: 'root'
})

export class CustomerService {
  constructor(private http: HttpClient) {
  }

  getCustomer() {
    return this.http.get('/api/customer')
      .pipe(
        map((data: Customer[]) => {
          return data;
        }));
  }
}
